import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FamiliarSection } from '../components/FamiliarSection';
import { IdentificationSection } from '../components/IdentificationSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhyNothingWorksSection } from '../components/WhyNothingWorksSection';
import { MethodSection } from '../components/MethodSection';
import { WhatChangesSection } from '../components/WhatChangesSection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { FinalOfferSection } from '../components/FinalOfferSection';
export function LandingPage() {
  return <main className="w-full" data-id="element-231">
      <HeroSection data-id="element-232" />
      <FamiliarSection data-id="element-233" />
      <IdentificationSection data-id="element-234" />
      <MechanismSection data-id="element-235" />
      <WhyNothingWorksSection data-id="element-236" />
      <MethodSection data-id="element-237" />
      <WhatChangesSection data-id="element-238" />
      <ObjectionsSection data-id="element-239" />
      <FinalOfferSection data-id="element-240" />
    </main>;
}